require('webpack-jquery-ui/datepicker');
require('jquery-ui/ui/i18n/datepicker-ru');
require('webpack-jquery-ui/selectmenu');
require("../app/form.coffee")
require("../app/bulletin_filter.coffee")
require('../app/news_popup.coffee')

# тут были проблемы со всплывахами и инициализациией формы, в отличии от остальных страниц
# пришлось отставить так

window.pageInitFlag = false

pageInit = ->
  new window.Form()
  new window.BulletinFilter()

$(document).ready ->
  if window.pageInitFlag == false
    pageInit()
  window.pageInitFlag = true



// WEBPACK FOOTER //
// ./assets/javascripts/pages/bulletin.coffee